<template>
  <div style="display:inline;position:relative;">
    <v-card
      v-if="showDialogGeburtstage && fullscreenActive && geburtstagskinderMitAlter"
      id="showGeburtstage"
      style="
        position:fixed;z-index:250;left:0px;bottom:0px;
        width:100%;height:auto;
        pointer-events:none;
        box-shadow:rgba(0,0,0,0.2) 4px 4px 10px, rgba(0,0,0,0.2) -4px -4px 10px;
      "
      class="pa-3"
    >
      <v-carousel
        cycle
        height="30"
        hide-delimiter-background
        hide-delimiters
        :show-arrows="false"
      >
        <v-carousel-item
          v-for="(slide, i) in geburtstagskinderMitAlter"
          :key="i"
        >
          <v-sheet
            height="100%"
          >
            <v-row
              class="fill-height"
              align="center"
              justify="center"
              no-gutters
            >
              <div
                v-if="geburtstagskinderMitAlter.length > 1"
                style="display:inline-block;position:absolute;left:10px;top:50%;transform:translateY(-50%);opacity:60%;"
              >{{i + 1}} / {{geburtstagskinderMitAlter.length}}</div>
              <div style="position:relative;">
                <v-icon start class="mr-3" color="orange">mdi-cake-variant</v-icon><b>{{ slide.name }}</b> wird heute {{ slide.alter }}!
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <v-dialog
      v-model="meldungShow"
      width="1000"
    >
      <v-alert
        text
        :type="meldungType"
        class="white"
        style="font-size:200%;"
      >
        <h2 class="mb-3">{{ meldungTitle }}</h2>
        <div v-html="meldungText"></div>
      </v-alert>
    </v-dialog>
    <v-dialog
      v-model="showDialog"
      :fullscreen="fullscreenActive"
      :width="fullscreenActive ? '100%' : '800px'"
      scrollable persistent
      style="overflow:hidden;"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ma-0"
        >
          <v-icon>mdi-qrcode-scan</v-icon>
        </v-btn>
      </template>
      <v-card style="overflow:hidden;">
        <v-card-title
          v-show="!fullscreenActive"
          class="primary justify-end"
        >
          <v-btn
            @click="closeScanDialog()"
            text
            color="#ffffff"
          >x</v-btn>
        </v-card-title>
        <v-card-text
          v-show="!fullscreenActive"
        >
          
          <div class="pa-3">
            <p>
              Nach Klick auf "Scan starten" können die QR-Codes auf den Karten eingescannt werden.<br/>
              <b>Achtung:</b> Der Scan kann durch Drücken der "esc"-Taste bzw. "Zurück" geschlossen werden.<br/>
              Link zum automatischen Starten des Scans:<br/>
              <i>{{ $store.state.main.save.settings.app_url }}200?SCAN</i>
            </p>
            <p>
              Welche Website soll im Hintergrund angezeigt werden?
            </p>
            <v-text-field
              label="Adresse (z.B. meine-website.de/dashboard)"
              v-model="settings.urlDashboard"
              @change="updateSettings()"
            />
            <v-checkbox
              label="Auf der Website kann geklickt werden"
              v-model="settings.iframeKlickbar"
              @change="updateSettings()"
            />
            <v-checkbox
              label="automatisches Aktualisieren aktivieren"
              v-model="settings.reload"
              @change="updateSettings()"
            />
            <v-text-field
              v-if="settings.reload"
              type="number"
              label="Aktualisieren alle ... Sekunden"
              v-model="settings.reloadSeconds"
              @change="updateSettings()"
            />
            <v-checkbox
              label="Geburtstage anzeigen"
              v-model="settings.showGeburtstage"
              @change="updateSettings()"
            />
            <v-select
              v-if="settings.showGeburtstage"
              label="Klassen definieren"
              v-model="settings.showGeburtstageIdsKlassen"
              :items="$store.state.f200.store.klassen"
              item-text="name"
              item-value="id"
              multiple
              @change="updateSettings()"
            />
            <div align="center">
              <!--<v-btn @click="showMeldung({title: 'test', text: 'lorem ipsum dolor sit amet'})">
                meldung
              </v-btn>-->
            </div>
          </div>
        </v-card-text>
        <v-card-actions
          v-show="!fullscreenActive"
          class="primary justify-center"
        >
          <v-btn
            @click="toggleFullScreen()"
          >Scan starten</v-btn>
        </v-card-actions>
        <!--<div v-if="isLoading">
          <v-progress-linear
            indeterminate
          ></v-progress-linear>
        </div>-->

        <v-dialog v-model="isLoading" width="500">
          <v-progress-linear
            indeterminate
          ></v-progress-linear>
        </v-dialog>

        <div
          v-if="(isLoadingIframe && fullscreenActive)"
          style="
            position:fixed;z-index:1;
            top:0px;left:0px;width:100vw;height:100vh;
            border:none;
            background-color:rgba(0,0,0,0.8);color:#fff;"
        >
          <div class="loadingSpinner"></div>
        </div>
        <iframe
          id="200-scanAPI-iframe"
          v-if="fullscreenActive"
          :src="settings.urlDashboard"
          :style="`width:100vw;height:100vh;pointer-events:${settings.iframeKlickbar ? 'auto' : 'none'};border:none;`"
          class="black"
          @load="loadIframe();"
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
  },
  data: () => ({
    settings: {
      urlDashboard: '',
      reload: false,
      reloadSeconds: 300,
      iframeKlickbar: false,
      showGeburtstage: false,
      showGeburtstageIdsKlassen: [],
    },
    intervalAutoReload: null,
    showDialog: false,
    showDialogGeburtstage: false,
    geburtstagskinderMitAlter: [],
    fullscreenActive: false,
    eventListenerKeyUpSet: false,
    scannedValue: '',
    meldungShow: false,
    meldungTitle: '',
    meldungText: '',
    meldungType: '',
    isLoading: false,
    isLoadingIframe: false,
  }),
  computed: {
    //
  },
  watch: {
    showDialog(neu, alt) {
      if (!neu) {
        document.getElementById('app').style.cursor = 'default';
      }
    }
  },
  methods: {
    closeScanDialog() {
      this.$emit('closeDialog', {
        hideLoadingAnimation: false,
        type: 'loaddata',
        data: {},
      });
      this.showDialog = false;
    },
    updateSettings() {
      if (this.settings.urlDashboard.substring(0, 8) !== 'https://') {
        if (this.settings.urlDashboard.substring(0, 7) === 'http://') {
          this.settings.urlDashboard = this.settings.urlDashboard.substring(7, this.settings.urlDashboard.length);
        }
        this.settings.urlDashboard = 'https://'+this.settings.urlDashboard;
      }
      localStorage.setItem('f200_scanApi_settings', JSON.stringify(this.settings));
    },
    checkFullscreen() {
      if (!this.fullscreenActive) {
        return false;
      }
      return true;
    },
    loadIframe() {
      setTimeout(() => {
        this.isLoadingIframe = false;
      }, 500);
    },
    toggleFullScreen() {
      if (this.fullscreenActive) {
        this.isLoadingIframe = false;
        this.fullscreenActive = false;
        document.getElementById('app').style.cursor = 'default';
        clearInterval(this.intervalAutoReload);
      } else {
        this.isLoadingIframe = true;
        this.fullscreenActive = true;
        if (!this.settings.iframeKlickbar) {
          document.getElementById('app').style.cursor = 'none';
        }
        if (this.settings.reload) {
          this.intervalAutoReload = setInterval(() => {
            this.isLoadingIframe = true;
            document.getElementById('200-scanAPI-iframe').src = document.getElementById('200-scanAPI-iframe').src
            // Lade aktuelle Kinder
            this.$emit('closeDialog', {
              hideLoadingAnimation: false,
              type: 'loaddata',
              data: {},
            });
            setTimeout(() => {
              if (this.settings.showGeburtstage) {
                const heute = new Date();
                const heuteMonat = heute.getMonth() + 1;
                const heuteTag = heute.getDate();
                const aktuellesJahr = heute.getFullYear();
                this.geburtstagskinderMitAlter = this.$store.state.f200.store.kinder
                .filter(person => {
                  const geburtsdatum = new Date(person.date_geburtstag);
                  const geburtsMonat = geburtsdatum.getMonth() + 1;
                  const geburtsTag = geburtsdatum.getDate();
                  if (!this.settings.showGeburtstageIdsKlassen.includes(person.id_klasse)) {
                    return false;
                  }
                  return geburtsMonat === heuteMonat && geburtsTag === heuteTag;
                })
                .map(person => {
                  const geburtsdatum = new Date(person.date_geburtstag);
                  const geburtsjahr = geburtsdatum.getFullYear();
                  const alter = aktuellesJahr - geburtsjahr;
                  return {
                    name: person.name,
                    alter: alter
                  };
                });
                console.log('GEBURTSTAGE:', this.geburtstagskinderMitAlter);
                if (this.geburtstagskinderMitAlter.length > 0) {
                  this.showDialogGeburtstage = true;
                } else {
                  this.showDialogGeburtstage = false;
                }
              }
            }, 8000);
          }, this.settings.reloadSeconds * 1000);
        }
        // Geburtstage
        if (this.settings.showGeburtstage) {
          const heute = new Date();
          const heuteMonat = heute.getMonth() + 1;
          const heuteTag = heute.getDate();
          const aktuellesJahr = heute.getFullYear();
          this.geburtstagskinderMitAlter = this.$store.state.f200.store.kinder
          .filter(person => {
            const geburtsdatum = new Date(person.date_geburtstag);
            const geburtsMonat = geburtsdatum.getMonth() + 1;
            const geburtsTag = geburtsdatum.getDate();
            if (!this.settings.showGeburtstageIdsKlassen.includes(person.id_klasse)) {
              return false;
            }
            return geburtsMonat === heuteMonat && geburtsTag === heuteTag;
          })
          .map(person => {
            const geburtsdatum = new Date(person.date_geburtstag);
            const geburtsjahr = geburtsdatum.getFullYear();
            const alter = aktuellesJahr - geburtsjahr;
            return {
              name: person.name,
              alter: alter
            };
          });
          if (this.geburtstagskinderMitAlter.length > 0) {
            this.showDialogGeburtstage = true;
          } else {
            this.showDialogGeburtstage = false;
          }
        }
      }
    },
    showMeldung(meldung) {
      this.meldungTitle = meldung.title || '';
      this.meldungText = meldung.text || '';
      this.meldungType = meldung.type || 'success';
      this.meldungShow = true;
      setTimeout(() => {
        this.meldungShow = false;
      }, meldung.duration || 6000);
    },
    async trySaveSettings() {
      let value = this.scannedValue.split('-');
      let url = false;
      const body = new FormData();
      if (
        value[0] !== '200'
        || value.length !== 4
      ) {
        this.showMeldung({
          title: 'Ungültiger QR-Code!',
          text: '',
          type: 'error',
        });
      } else {
        if (
          value[2] === '1'
        ) {
          url = '200/200/?func=getSettings';
          body.append('code', this.$store.state.login.session.code);
          body.append('dataToSave', JSON.stringify({
            dataToSave: {
              type: 'anwesenheitsstatus',
              data: {
                id_kind: parseInt(value[1], 10),
              },
            },
          }));
        }
      }
      this.scannedValue = '';
      if (url) {
        // SENDEN
          this.isLoading = true;
          await fetch(`${process.env.VUE_APP_API_HOST}/${url}`, {
            method: 'POST',
            body,
          })
            .then((response) => response.json())
            .then((res) => {
              this.showMeldung(res.meldung);
              this.isLoading = false;
            })
            .catch((error) => {
              console.error(error);
              this.showMeldung({
                title: 'Es ist ein Fehler aufgetreten',
                text: 'Bitte erneut versuchen...',
                type: 'error',
              });
              this.isLoading = false;
            });
        //
      }
    },
  },
  mounted() {
    this.fullscreenActive = this.checkFullscreen();
    if (!this.eventListenerKeyUpSet) {
      if (localStorage.getItem('f200_scanApi_settings')) {
        this.settings = JSON.parse(localStorage.getItem('f200_scanApi_settings'));
      }
      window.addEventListener("fullscreenchange", (event) => {
        this.fullscreenActive = this.checkFullscreen();
      });
      window.addEventListener("keyup", (event) => {
        //console.log(event.key);
        event.preventDefault();
        if (
          this.showDialog
          && this.fullscreenActive
          && !this.meldungShow
        ) {
          if (event.key.length === 1) {
            this.scannedValue += event.key;
          } else if (event.key === 'Enter') {
            this.trySaveSettings();
          } else if (['Escape'].includes(event.key) && this.checkFullscreen()) {
            this.toggleFullScreen();
          } else {
            //console.log(event.key);
          }
        }
      });
    }
    this.eventListenerKeyUpSet = true;
    if (Object.keys(this.$route.query).includes('SCAN')) {
      this.showDialog = true;
      this.toggleFullScreen();
    }
    /*setTimeout(() => {
      console.log(JSON.stringify(this.$route.query));
    }, 1000);*/
  },
};
</script>

<style>
  .loadingSpinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(0deg);
  }

  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
</style>